import React from 'react';
import ManagementContextPropsType from './ManagementContextPropTypes';
import config from './config';

export default React.createContext<ManagementContextPropsType>(config);
